import TickRegularIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons/TickRegular";
import styles from "./Confirmation.module.scss";

export const Confirmation = () => {
  return (
    <div className={styles.successfulConfirmationContainer} aria-live="polite">
      <TickRegularIcon className={styles.tick} />
      <div id="notifyme:confirmation:wrapper">
        <p
          data-testid="confirmation:title"
          className={styles.successfulConfirmationTitle}
        >
          We&rsquo;ve just sent you a confirmation email
        </p>

        <p data-testid="confirmation:message">
          We&rsquo;ll contact you when this product becomes available.
        </p>
      </div>
    </div>
  );
};
